/**
 * Application-wide constants.
 */

export const SUPPORTED_CURRENCIES = Object.freeze(['CAD', 'USD']);
